import {IStore} from "modules/types/store";

export const getRoundRankings = (state: IStore) => state.rankings.ranking;
export const getOverallRankingsSelector = (state: IStore) => state.rankings.overallRankings;
// export const getRegularLeagueRankingsSelector = (state: IStore) => state.rankings.leagueRankings;

export const getFilterRanking = (state: IStore) => state.rankings.filter;
